export default function parseUrl(url, params) {
  if (params) {
    for (let k in params) {
      if (url.indexOf('?') > -1) {
        url += '&' + k + '=' + params[k];
      } else {
        url += '?' + k + '=' + params[k];
      }
    }
  }
  return url;
}



// WEBPACK FOOTER //
// ./src/util/parse-url.js